import { jsonObject, jsonMember, jsonArrayMember } from 'typedjson';

@jsonObject
export class SnoozeInfo {
  @jsonMember
  public userId: string;
  @jsonMember
  public snoozeEndTimestamp: number;
}
